import React from 'react';
import TicketQueue from './TicketQueue';

const UnassignedTickets = () => (
  <TicketQueue
    title="Unassigned Tickets"
    description="Review, prioritize, and assign tickets waiting for ownership"
    initialFilters={{ assigned: false }}
    hideExtraActions={true}
  />
);

export default UnassignedTickets;

